define(
    'collections/users.collection',[
        'loader',
        'config',

        'models/user.model'
    ],
    function(Loader, Config, userModel)
    {
        var _ = Loader._;

        var UsersCollection = Loader.Backbone.Collection.extend({
            model: userModel,

            initialize: function()
            {
                this.addMe();
            },

            addMe: function()
            {
                this.add({
                    id:             window['UserID']        || 1,
                    login:          window['UserLogin']     || '',
                    name:           window['UserName']      || '',
                    groupId:        window['GroupID']       || 3,
                    avatar:         window['UserAvatar']    || '',
                    title:          window['UserTitle']     || '',
                    sex:            window['UserSex']       || 0,
                    age:            window['UserAge']       || 0,
                    birthDate:      window['UserBirthDate'] || '',
                    registered:     window['UserRegistered'] || null,
                    inviteCode:     window['UserInviteCode'] || null,
                    posts:          window['UserPosts']     || 0,
                    lastPost:       window['UserLastPost']  || null,
                    lastVisit:      window['UserLastVisit'] || null,
                    totalTime:      window['UserTotalTime'] || null,
                    respectPlus:    window['UserRespectPlus'] || 0,
                    respectMinus:   window['UserRespectMinus'] || 0,
                    positivePlus:   window['UserPositivePlus'] || 0,
                    positiveMinus:  window['UserPositiveMinus'] || 0,
                    birthDateB64:   window['UserBirthDateB64'] || -1,
                    mail:           '',
                    mailMD5:        window['UserMailMD5']   || ''
                });
            },

            getMe: function()
            {
                return this.get(window['UserID'] || 1);
            }
        });

        return UsersCollection;
    }
);
